import type { Nullable } from 'types';

import type { OrganizationPermission, OrganizationRole } from './types';

/**
 * @GET /organisation/details
 * @PATCH /organisation/details
 */
export type OrganizationDetailsDTO = {
  name: string;
  companyName: Nullable<string>;
  vatCode: Nullable<string>;
  address1: Nullable<string>;
  address2: Nullable<string>;
  postcode: Nullable<string>;
  city: Nullable<string>;
  countryCode: Nullable<string>;
};

/**
 * @GET /organisations
 * @POST /organisations
 */
export type OrganizationEntryDTO = {
  id: string;
  name: string;
  role: OrganizationRole;
  permissions: OrganizationPermission[];
};

export enum OrganizationMemberStatusDTO {
  ACTIVE = 'active',
  PENDING = 'pending',
  EXPIRED = 'expired',
}

/**
 * @GET /organisation/members
 * @POST /organisation/members
 * @PATCH /organisation/members/{id}
 */
export type OrganizationMemberDTO = {
  // Invited people who haven't joined yet have no membership - and no id - to act on.
  id: Nullable<number>;
  email: string;
  fullName: Nullable<string>;
  role: OrganizationRole;
  status: OrganizationMemberStatusDTO;
  addedAt: string;
  lastLoginAt: Nullable<string>;
};

/**
 * @POST /organisation/invitations
 */
export type OrganizationInvitationDTO = {
  id: number;
  email: string;
  role: OrganizationRole;
  status: OrganizationMemberStatusDTO;
  expiresAt: string;
};
